<div (click)="notificationClick()" class="notification-badge">
    <div class="notification-content">
        <div class="notification-sub-msg-1">
            <span class="material-icons">{{notifyType}}</span>
            <span>&nbsp;{{message1}}</span>
        </div>
        <div class="notification-sub-msg" *ngIf="!(message2 == undefined || message2 == null || message2 == '')">
            <span style="font-weight: 400;font-size: 14px;">&nbsp;{{message2}}</span>
        </div>
    </div>
</div>